module.exports = {
  env: 'prod',
  domain: ['ncep.astrazeneca.cn'],
  mobileDomain: 'ncep-h5.astrazeneca.cn',
  aegisId: '4eomLC5DRbE0gGp6dY',
  reportDomain: 'baike.sparta.html5.qq.com',
};
